"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const _ActionTypes = ActionTypes.default(namespace);
    function setRoot(node) {
        return {
            type: _ActionTypes.SET_ROOT,
            root: node
        };
    }
    function fetchTree(node, types = ['FOLDER'], hierarchyType = 'MINIMAL', includeSelf = false, markAutomaticOrderFolders, includeSubFolders, subFoldersDepth) {
        return {
            type: _ActionTypes.FETCH_TREE_REQUEST,
            payload: {
                node,
                types,
                hierarchyType,
                includeSelf,
                markAutomaticOrderFolders,
                includeSubFolders,
                subFoldersDepth
            }
        };
    }
    function fetchTreeSuccess(data) {
        return {
            type: _ActionTypes.FETCH_TREE_SUCCESS,
            data
        };
    }
    function fetchTreeFailure() {
        return {
            type: _ActionTypes.FETCH_TREE_FAILURE
        };
    }
    function selectFile(node, selected) {
        return {
            type: _ActionTypes.SELECT_FILE,
            node,
            selected
        };
    }
    function copyChangeExpand(expand, node) {
        return {
            type: _ActionTypes.COPY_CHANGE_EXPAND,
            expand,
            node
        };
    }
    function copyFilesToggleOverlay(mode, folder) {
        return {
            type: _ActionTypes.COPY_FILES_TOGGLE_OVERLAY,
            mode,
            folder
        };
    }
    function copyFilesRequestAction(mode, files, target, ignored, groups = [], revisionDuplicates = false) {
        if (mode === 'IMPORT') {
            return {
                type: _ActionTypes.COPY_FILES_REQUEST,
                mode,
                files,
                target,
                ignored,
                groups,
                revisionDuplicates
            };
        }
        return {
            type: _ActionTypes.COPY_FILES_REQUEST,
            mode,
            files,
            target,
            ignored,
            revisionDuplicates
        };
    }
    function copyFilesSuccessAction(payload) {
        return {
            type: _ActionTypes.COPY_FILES_SUCCESS,
            payload
        };
    }
    function copyFilesFailureAction(error) {
        return {
            type: _ActionTypes.COPY_FILES_FAILURE,
            payload: error
        };
    }
    function copySelectTargetAction(target) {
        return {
            type: _ActionTypes.COPY_SELECT_TARGET,
            target
        };
    }
    function copyFilesReset() {
        return {
            type: _ActionTypes.COPY_FILES_RESET
        };
    }
    function setCopyOrMoveRootExpanded(flag) {
        return {
            type: _ActionTypes.COPY_OR_MOVE_FILES_ROOT_EXPANDED_REQUEST,
            flag
        };
    }
    function userToggleCopyOrMoveResult() {
        return {
            type: _ActionTypes.USER_TOGGLE_COPY_OR_MOVE_RESULT
        };
    }
    function clear() {
        return {
            type: _ActionTypes.CLEAR
        };
    }
    function removeItemsFromTree(files) {
        return {
            type: _ActionTypes.REMOVE_ITEMS_FROM_TREE,
            data: {
                files: files
            }
        };
    }
    return {
        setRoot,
        userToggleCopyOrMoveResult,
        setCopyOrMoveRootExpanded,
        copyFilesReset,
        copySelectTargetAction,
        copyFilesFailureAction,
        copyFilesRequestAction,
        copyFilesSuccessAction,
        copyFilesToggleOverlay,
        copyChangeExpand,
        fetchTreeFailure,
        fetchTreeSuccess,
        fetchTree,
        selectFile,
        clear,
        removeItemsFromTree
    };
}
exports.default = default_1;
//# sourceMappingURL=actions.js.map